import React, { useState } from 'react'

//components
import DepositsTable from './DepositsTable'
import CashRegisterTabHeader from '../CashRegisterTabHeader'
import CashRegisterTabsContent from '../CashRegisterTabsContent'

function DepositsTab(props) {
  const [searchText, setSearchText] = useState('')

  const onSearch = searchText => {
    setSearchText(searchText)
  }

  return (
    <div>
      <CashRegisterTabHeader
        shopsList={props.shopsList}
        selectedOption={props.selectedOption}
        setSelectedOption={option => {
          props.setSelectedOption(option)
        }}
        search={true}
        onSearch={onSearch}
      />
      <CashRegisterTabsContent component={DepositsTable} selectedOption={props.selectedOption} shopsList={props.shopsList} searchText={searchText} />
    </div>
  )
}

export default DepositsTab
